import type {
  ClickableLabeledImageItem,
  SuggestionButtonPopover,
} from '@/scenes/Editor/components/EditWithAI/components/suggestedButtonSets'

type PoseGridPopoverParams = {
  title: string
  aspectRatio: string
  items: ClickableLabeledImageItem[]
  columns: number
  skeletonCount: number
  onLoadMore: () => void
  isLoadingMore: boolean
  skeletonVariant?: 'default' | 'gradient'
}

export function createPoseGridPopover({
  title,
  aspectRatio,
  items,
  columns,
  skeletonCount,
  onLoadMore,
  isLoadingMore,
  skeletonVariant = 'gradient',
}: PoseGridPopoverParams): SuggestionButtonPopover {
  return {
    designType: 'grid',
    title,
    width: 320,
    height: 400,
    columns,
    skeletonCount,
    aspectRatio,
    items,
    onLoadMore,
    isLoadingMore,
    loadMoreSkeletonCount: skeletonCount,
    skeletonVariant,
  }
}
